/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {RecyclerListView, DataProvider, LayoutProvider} from 'recyclerlistview/web';

import Loading from '@/assets/icons/Loading.gif';
import * as PC_COMMON_FUNCTION from '@/libs/appHelper';
import {consoleLog} from '@/libs/consoleHelper';

import VerticalNavigation from '../../../navigation/verticalNavigation/VerticalNavigation';
import Profile from '../../../profile/Profile';

import './ListView.less';

const PREVIOUS = 'PREVIOUS';
const NEXT = 'NEXT';
const MAX_LIST_VIEW = 6;

class ListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 0,
      totalPage: 0,
      showList: [],
      lastViewId: 0,
      listContent: [],
    };
    this.onClick = this.onClick.bind(this);
    this.setShowList = this.setShowList.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listContent) {
      const {listContent} = nextProps;
      if (this.props.isFullView === false || this.props.isFullView === undefined) {
        const totalPage = Math.ceil(listContent.length / MAX_LIST_VIEW);
        this.setState({
          listContent,
          totalPage,
        });
        const maxInitShow = listContent.length < MAX_LIST_VIEW ? listContent.length : MAX_LIST_VIEW;
        const activeList = this.checkActiveList(listContent);
        // noActiveList
        if (activeList === undefined) {
          this.setState({
            activePage: totalPage > 1 ? 1 : 0,
          });
          this.setShowList(listContent, 0, maxInitShow);
        } else {
          // show latestActiveList
          this.showCurrentActiveList(listContent, activeList);
        }
      } else {
        this.ShowAll(listContent);
        this.setState({
          listContent,
          totalPage: 1,
        });
      }
    }
  }

  // eslint-disable-next-line react/sort-comp
  showCurrentActiveList = (listContent, activeList) => {
    let currentListShow = 0;
    // const currentActivePage = 1;
    while (currentListShow <= activeList) {
      currentListShow += MAX_LIST_VIEW;
    }
    let beginingId;
    let endId;
    // lesss than MAX_LIST_VIEW in the end of listContent
    if (currentListShow > listContent.length) {
      endId = listContent.length;
      beginingId = PC_COMMON_FUNCTION.getTheBiggestMod(listContent.length, MAX_LIST_VIEW);
    } else {
      beginingId = currentListShow - MAX_LIST_VIEW;
      endId = currentListShow;
    }
    this.setState({
      activePage: currentListShow / MAX_LIST_VIEW,
    });
    this.setShowList(listContent, beginingId, endId);
  };

  // eslint-disable-next-line class-methods-use-this
  checkActiveList = (listContent) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const list of listContent) {
      if (list.Active) {
        return list.Id;
      }
    }
    return undefined;
  };

  /**
   * @deprecated
   * @param {*} e
   * @param {*} v
   */
  onClick(e) {
    const {listContent} = this.state;
    switch (e.currentTarget.id) {
      case PREVIOUS: {
        this.actionPrevious(listContent, this.state.lastViewId);
        const newActivePage = this.state.activePage - 1;
        this.setState({
          activePage: newActivePage === 0 ? this.state.totalPage : newActivePage,
        });
        break;
      }
      case NEXT: {
        this.actionNext(listContent, this.state.lastViewId);
        const newActivePage = this.state.activePage + 1;
        this.setState({
          activePage: newActivePage > this.state.totalPage ? 1 : newActivePage,
        });
        break;
      }
      default:
        break;
    }
  }

  onClickList = (e) => {
    const {listContent} = this.state;
    const {multipleSelect} = this.props;
    const selectedId = e.currentTarget.id;
    const tempListContent = listContent;
    let tempMultipleSelect = multipleSelect;
    if (multipleSelect === undefined) {
      tempMultipleSelect = false;
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const listId in listContent) {
      if (
        (typeof listContent[listId].Id === 'number' && listContent[listId].Id === parseInt(selectedId, 10)) ||
        listContent[listId].Id === selectedId
      ) {
        if (tempMultipleSelect === true && tempListContent[listId].Active === true) {
          tempListContent[listId].Active = false;
        } else {
          tempListContent[listId].Active = true;
        }

        const selectedList = tempListContent[listId];
        consoleLog('onClickList', {selectedList, tempListContent});
        this.props.callBackSelectedList(selectedList);
      } else if (tempMultipleSelect !== true) tempListContent[listId].Active = false;
    }
    this.setState({
      listContent: tempListContent,
    });
  };

  /**
   * @deprecated
   * @param {*} listViewAll
   * @param {*} lastViewId
   */
  actionPrevious(listViewAll, lastViewId) {
    const endId =
      lastViewId - MAX_LIST_VIEW <= 0
        ? listViewAll.length
        : lastViewId % MAX_LIST_VIEW === 0
        ? lastViewId - MAX_LIST_VIEW
        : PC_COMMON_FUNCTION.getTheBiggestMod(listViewAll.length, MAX_LIST_VIEW);
    const beginingId =
      endId % MAX_LIST_VIEW === 0
        ? endId - MAX_LIST_VIEW
        : PC_COMMON_FUNCTION.getTheBiggestMod(listViewAll.length, MAX_LIST_VIEW);
    this.setShowList(listViewAll, beginingId, endId);
  }

  /**
   * @deprecated
   * @param {*} listViewAll
   * @param {*} lastViewId
   */
  actionNext(listViewAll, lastViewId) {
    const beginingId = lastViewId >= listViewAll.length ? 0 : lastViewId;
    const endId =
      beginingId === 0
        ? listViewAll.length > MAX_LIST_VIEW
          ? MAX_LIST_VIEW
          : listViewAll.length
        : lastViewId + MAX_LIST_VIEW > listViewAll.length
        ? listViewAll.length
        : lastViewId + MAX_LIST_VIEW;
    this.setShowList(listViewAll, beginingId, endId);
  }

  ShowAll(listViewAll) {
    this.setState({
      showList: listViewAll,
      lastViewId: 0,
    });
  }

  rowRenderer = (type, data, index) => {
    // consoleLog("rowRenderer", index, data);
    // TODO the naming of active state on each data is was possible not determine as not an active row based on previous code version below feature of multiple selections, if it was then the active row should be determined as another name or otherwise
    const classNameActive = data && data.Active ? ' activeRowList' : '';
    return (
      <div
        className={`row col-md-12 rowListViewParent middleAlign${classNameActive}`}
        key={index}
        id={data.Id}
        onClick={this.onClickList}
      >
        <div className={this.props.multipleSelect ? 'rowListViewChild with-checkbox' : 'rowListViewChild'}>
          {this.props.multipleSelect && (
            <input
              type="checkbox"
              id={`checkbox-item-${data.Id}`}
              name={data.Id}
              className="checkbox-item"
              // value="value"
              checked={data.Active}
              onChange={this.onClickList}
            />
          )}
          <div className="listView">
            <div className="row listviewName">
              <span>{data.Name}</span>
            </div>
            <div className={data.Preview === null ? 'row preview-hide' : 'row previewView '}>
              <span className="previewText">
                {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>{"../" + splitString[splitString.length - 2] + "/" + splitString[splitString.length - 1]}</i> */}
                {data.Preview}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  generateListView(showList = []) {
    const {height} = this.props;
    if (!showList.length) return null;
    const layoutProvider = new LayoutProvider(
      () => 0,
      (type, dim) => {
        dim.height = 80;
        // eslint-disable-next-line no-restricted-globals
        dim.width = window.innerWidth - 50;
      },
    );
    const dataProvider = new DataProvider((r1, r2) => r1 !== r2).cloneWithRows(showList);
    const style = {};
    if (height) style.height = height;
    return (
      <RecyclerListView
        style={style}
        dataProvider={dataProvider}
        layoutProvider={layoutProvider}
        rowRenderer={this.rowRenderer}
      />
    );
  }

  /**
   * Set show cycle history
   * @param listViewAll
   * @param beginingId
   * @param endId
   * @returns showCycleHistory
   * @returns lastCycleHistory
   */
  setShowList(listViewAll, beginingId, endId) {
    const showList = [];
    for (let i = beginingId; i < endId; i++) {
      showList[i] = listViewAll[i];
    }
    this.setState({
      showList,
      // lastViewId: i,
    });
  }

  generateNavigator() {
    // const disableNavigator =
    //   this.state.listContent === undefined ? true : this.state.listContent.length <= MAX_LIST_VIEW;
    return (
      <VerticalNavigation
        onClick={this.onClick}
        totalPage={this.state.totalPage}
        activePage={this.state.activePage}
        type={this.props.navigationType}
      />
    );
  }

  renderView = (dataState) => {
    // handle not set  data state. because default data state is ListView.state.AVAILABLE_DATA
    if (dataState === ListView.state.AVAILABLE_DATA) {
      // eslint-disable-next-line no-param-reassign
      if (this.props.listContent === undefined) dataState = -1;
      // eslint-disable-next-line no-param-reassign
      else if (this.props.listContent.length === 0) dataState = ListView.state.NO_DATA;
    }

    switch (dataState) {
      case ListView.state.WAITING_DATA:
        return (
          this.props.className !== ' usbListView' && (
            <div className="loading center">
              <img
                className="loadingIcon"
                src={Loading}
                alt={Loading}
                width={125}
                height={125}
              />
              <br />
              <span>Please Wait!</span>
            </div>
          )
        );
      case ListView.state.NO_DATA: {
        const listNotFound = (
          <div className="center">
            <Profile
              label="Not Found"
              profileNotFound
            />
          </div>
        );
        return <div className="notFoundRow center">{listNotFound}</div>;
      }
      case ListView.state.AVAILABLE_DATA: {
        const listContentWidth = this.props.isFullView === true ? 'col-md-12' : 'col-md-11';
        return (
          <>
            <div className={`${listContentWidth} col-cycleList`}>{this.generateListView(this.state.showList)}</div>
            {!this.props.isFullView && this.props.listContent && this.props.listContent.length !== 0 && (
              <div className="col-md-1 col-navigator">{this.generateNavigator()}</div>
            )}
          </>
        );
      }
      default:
        return null;
    }
  };

  render() {
    const {className, isFullView, dataState} = this.props;
    const scrollView = isFullView ? ' scrollListView' : '';
    return (
      <div
        className={
          className !== undefined ? `row mainListView${scrollView}${className}` : `row mainListView${scrollView}`
        }
      >
        {this.renderView(dataState)}
      </div>
    );
  }
}
export default ListView;

/**
 * @enum {Number}
 */
// TODO need to move this into the more common enum that follows derived enum name
ListView.state = {
  WAITING_DATA: 0,
  NO_DATA: 1,
  AVAILABLE_DATA: 2,
};
ListView.defaultProps = {
  dataState: ListView.state.AVAILABLE_DATA,
};
